// extracted by mini-css-extract-plugin
export default {"select_label_table":"dropdownGroup_select_label_table__tqMrT","table_select":"dropdownGroup_table_select__L0kNU"};